import { useState, useEffect } from "react";
import { BiSearch } from "react-icons/bi";
import { AiFillFire } from "react-icons/ai";
import Navbar from "../Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAllMenu } from "../../store/api/listingmenu";
import { useDispatch, useSelector } from "react-redux";
import { StateType } from "../../store/Reducer/index.reducer";
import { MenuProduct } from "../../store/Type/menu.type";
import { MEDIA_IMAGE_URL, PRODCUCTIMAGE_BASE_URL } from "../../constant";
import Footer from "../Footer";
import { Drawer } from "antd";
import type { DrawerProps } from "antd/es/drawer";
import text_truncate from "../TextTruncate";
import { getAllTags } from "../../store/api/tag";
import { BsChevronDown } from "react-icons/bs";
import { getAllCategories } from "../../store/api/category";
import AppButton from "../AppButton";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import ListingBlock from "./listingBlock";
import { boolean } from "yup/lib/locale";
import { getCart, handleAddToCart } from "../../store/api/cart";

const Index = (props: any) => {
    const { t } = useTranslation("listingMenu");
    const dispatch = useDispatch<any>();
    const date = new Date();
    const { zone, id, currentVenue, restaurantid } = useParams();
    const device_time =
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    const currency = useSelector(
        (state: StateType) => state.category.categoryRes.currency
    );
    const { totalQty, loader }: any = useSelector(
        (state: StateType) => state?.cart
    );
    const menuDetails = useSelector((state: StateType) => state?.menu?.menu);

    const dietTag = useSelector((state: StateType) => state.tags.tags);
    const { categoryRes } = useSelector((state: StateType) => state.category);

    const categoryRem = useSelector(
        (state: StateType) => state.menu.menu.$products
    );
    const [quantity] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [filtervisible, setFilterVisible] = useState(false);
    const [menuvisible, setMenuVisible] = useState(false);
    const [tag, setTag] = useState<number[]>([]);
    const [selectedTag, setSelectedTag] = useState<number[]>([]);
    const [menuCategory, setMenuCategory] = useState<number[]>([]);
    const [openSearch, setOpenSearch] = useState(false);

    const [addprod, setAddProd] = useState(false);

    const [filterPlacement, setFilterPlacement] =
        useState<DrawerProps["placement"]>("left");
    const [menuPlacement, setMenuPlacement] =
        useState<DrawerProps["placement"]>("right");

    useEffect(() => {
        const data: any = { id, tag: String(tag) };
        id && dispatch(getAllMenu(data));
        restaurantid && dispatch(getAllTags(restaurantid, zone));
        dispatch(getAllCategories(currentVenue, zone, device_time));
        window.scrollTo({
            top: 0,
            left: 0,
        });
    }, [tag]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
    }, []);

    const openSearchHandler = (e: any) => {
        e.preventDefault();
        setOpenSearch(!openSearch);
    };
    const onCancel = (e: any) => {
        e.preventDefault();
        setOpenSearch(!openSearch);
    };
    const handleFilter = () => {
        setTag(selectedTag);
        setFilterVisible(false);
    };
    const onClose = () => {
        setFilterVisible(false);
    };
    const menuClose = () => {
        setMenuVisible(false);
    };
    const showFilterDrawer = () => {
        setFilterVisible(true);
    };
    const showMenuDrawer = () => {
        setMenuVisible(true);
    };
    const handleCheckbox = (id: number) => {
        if (tag.includes(id)) {
            const filteredTag = tag.filter((item) => item !== id);
            setSelectedTag(filteredTag);
        } else {
            setSelectedTag([...tag, id]);
        }
    };
    const handleMenuCheck = (id: number) => {
        const dataa: any = { id, menuCategory: String(menuCategory) };
        id && dispatch(getAllMenu(dataa));
        setMenuVisible(false);
        if (!menuCategory.includes(id)) {
            setMenuCategory([...menuCategory, id]);
        }
    };

    const navigate = useNavigate();

    const handleAddRequest = (productid?: number) => {
        const data = {
            productId: productid,
            quantity: quantity,
            zone: zone,
        };

        dispatch(handleAddToCart(data, true));
    };

    useEffect(() => {
        dispatch(getCart());
    }, []);

    return (
        <>
            <Navbar showArrow showLogo venue={currentVenue} />
            {loader ? (
                <Loader classType="loading-spinner" />
            ) : (
                <div className="whole_listing">
                    {categoryRem && (
                        <div className="listing-menu container">
                            <div className="top-bar">
                                <div className="topbar_left">
                                    <div className="search-icon">
                                        <BiSearch
                                            className="bisearch"
                                            onClick={openSearchHandler}
                                        />
                                    </div>
                                    <div
                                        className="filter-icon"
                                        onClick={showFilterDrawer}
                                    >
                                        <img src="/Images/filter.png" />
                                    </div>
                                </div>
                                <div
                                    className="topbar_right"
                                    onClick={showMenuDrawer}
                                >
                                    {t("default:common.buttons.viewMenu")}
                                    <BsChevronDown className="viewmenu_arrow" />
                                </div>
                            </div>
                            <div
                                className={
                                    openSearch
                                        ? "search-bar active"
                                        : "search-bar"
                                }
                            >
                                <div className="input-search">
                                    <input
                                        type="text"
                                        onChange={(event) => {
                                            setSearchTerm(event.target.value);
                                        }}
                                    />
                                    <BiSearch
                                        className="bisearch_inner-icon"
                                        onClick={openSearchHandler}
                                    />
                                </div>
                                <div className="cancel-btn" onClick={onCancel}>
                                    {t("default:common.buttons.cancel")}
                                </div>
                            </div>

                            <div className="menu_wrapper">
                                <div className="menu_innerbox">
                                    {menuDetails?.$products
                                        ?.filter((val) => {
                                            if (searchTerm == "") {
                                                return val;
                                            } else if (
                                                val.name
                                                    .toLowerCase()
                                                    .includes(
                                                        searchTerm.toLowerCase()
                                                    )
                                            ) {
                                                return val;
                                            }
                                        })
                                        .map(
                                            (
                                                item: MenuProduct,
                                                index: number
                                            ) => {
                                                return (
                                                    <>
                                                        {item?.products
                                                            ?.length > 0 && (
                                                            <div className="subcat_wrapper">
                                                                {item?.products
                                                                    ?.length >
                                                                    0 && (
                                                                    <div className="cat_name">
                                                                        {
                                                                            item?.name
                                                                        }
                                                                    </div>
                                                                )}
                                                                <div className="menuitems_wrap">
                                                                    {item?.products?.map(
                                                                        (
                                                                            subcat: any,
                                                                            i: number
                                                                        ) => {
                                                                            return (
                                                                                <>
                                                                                    <Link
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                        to={
                                                                                            subcat.status ==
                                                                                                0 ||
                                                                                            zone ==
                                                                                                "guest-request"
                                                                                                ? ""
                                                                                                : `/menu/${currentVenue}/${zone}/detailmenu/${subcat.id}`
                                                                                        }
                                                                                        className="menu_itemslink"
                                                                                    >
                                                                                        <ListingBlock
                                                                                            imgsrc={
                                                                                                subcat.photo &&
                                                                                                `${MEDIA_IMAGE_URL}/images/product/${subcat.photo}`
                                                                                            }
                                                                                            item_mrp={
                                                                                                zone ==
                                                                                                "guest-request"
                                                                                                    ? ""
                                                                                                    : subcat.mrp
                                                                                            }
                                                                                            selectedTag={
                                                                                                subcat.tag
                                                                                            }
                                                                                            item_name={
                                                                                                subcat.name
                                                                                            }
                                                                                            description={
                                                                                                subcat.description
                                                                                            }
                                                                                            request_btn={
                                                                                                zone ==
                                                                                                "guest-request"
                                                                                                    ? true
                                                                                                    : false
                                                                                            }
                                                                                            price={
                                                                                                zone ==
                                                                                                "guest-request"
                                                                                                    ? false
                                                                                                    : true
                                                                                            }
                                                                                            tags={
                                                                                                zone ==
                                                                                                "guest-request"
                                                                                                    ? false
                                                                                                    : true
                                                                                            }
                                                                                            handleAdd={() => {
                                                                                                setAddProd(
                                                                                                    false
                                                                                                );
                                                                                                handleAddRequest(
                                                                                                    subcat.id
                                                                                                );
                                                                                                setTimeout(
                                                                                                    () => {
                                                                                                        setAddProd(
                                                                                                            true
                                                                                                        );
                                                                                                    },
                                                                                                    200
                                                                                                );
                                                                                            }}
                                                                                        />
                                                                                        {/* <div
                                                                                            className={
                                                                                                subcat.photo
                                                                                                    ? "menu_itemsactive"
                                                                                                    : "menu_items"
                                                                                            }
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                        >
                                                                                            {subcat.sold ==
                                                                                                0 && (
                                                                                                <div
                                                                                                    className={
                                                                                                        subcat.photo
                                                                                                            ? "sold_out"
                                                                                                            : "soldinactive"
                                                                                                    }
                                                                                                ></div>
                                                                                            )}
                                                                                            {subcat?.photo && (
                                                                                                <div className="listingproduct_img">
                                                                                                    <img
                                                                                                        src={
                                                                                                            subcat.photo
                                                                                                                ? `${MEDIA_IMAGE_URL}/images/product/${subcat.photo}`
                                                                                                                : "/Images/noimg-1.svg"
                                                                                                        }
                                                                                                        alt="menu"
                                                                                                    />
                                                                                                </div>
                                                                                            )}

                                                                                            <div
                                                                                                className={
                                                                                                    !subcat.photo
                                                                                                        ? "menu-wholecontent"
                                                                                                        : subcat.sold ==
                                                                                                          0
                                                                                                        ? "menuinnercontent_opacity"
                                                                                                        : "menu_inner_content"
                                                                                                }
                                                                                            >
                                                                                                <div>
                                                                                                    {(subcat.is_popular ==
                                                                                                        1 ||
                                                                                                        subcat.is_hot ==
                                                                                                            1) && (
                                                                                                        <div className="subcat_status">
                                                                                                            {subcat.is_popular ==
                                                                                                            1 ? (
                                                                                                                <div className="menu_status">
                                                                                                                    Popular
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}
                                                                                                            {subcat.is_hot ==
                                                                                                            1 ? (
                                                                                                                <div className="aifire">
                                                                                                                    <AiFillFire
                                                                                                                        className="aifire-icon"
                                                                                                                        color="#004ef9"
                                                                                                                    />
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                ""
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}

                                                                                                    <div className="menu_subcontentI">
                                                                                                        <h4>
                                                                                                            {text_truncate(
                                                                                                                {
                                                                                                                    str: subcat.name,
                                                                                                                    length: 20,
                                                                                                                    ending: null,
                                                                                                                }
                                                                                                            )}
                                                                                                        </h4>

                                                                                                        <p
                                                                                                            className={
                                                                                                                !subcat.photo
                                                                                                                    ? "menulist_para active active"
                                                                                                                    : subcat.is_popular ||
                                                                                                                      subcat.is_hot
                                                                                                                    ? "menulist_popularp"
                                                                                                                    : "menulist_para"
                                                                                                            }
                                                                                                        >
                                                                                                            {
                                                                                                                subcat.description
                                                                                                            }
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div className="menu_subcontent">
                                                                                                    <div className="price">
                                                                                                        {currency?.replace(
                                                                                                            /-/g,
                                                                                                            " "
                                                                                                        )}
                                                                                                        &nbsp;
                                                                                                        {
                                                                                                            subcat?.mrp
                                                                                                        }
                                                                                                    </div>

                                                                                                    <div
                                                                                                        className={
                                                                                                            !subcat.photo
                                                                                                                ? "menu__GVD active"
                                                                                                                : "menu__GVD"
                                                                                                        }
                                                                                                    >
                                                                                                        {subcat?.tags
                                                                                                            ?.slice(
                                                                                                                0,
                                                                                                                2
                                                                                                            )
                                                                                                            .map(
                                                                                                                (
                                                                                                                    tag: any,
                                                                                                                    index: number
                                                                                                                ) => {
                                                                                                                    return (
                                                                                                                        <span
                                                                                                                            key={
                                                                                                                                index
                                                                                                                            }
                                                                                                                        >
                                                                                                                            {
                                                                                                                                tag
                                                                                                                            }
                                                                                                                        </span>
                                                                                                                    );
                                                                                                                }
                                                                                                            )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div> */}
                                                                                    </Link>
                                                                                </>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                );
                                            }
                                        )}
                                </div>
                            </div>
                        </div>
                    )}

                    <Footer />
                    <div className="view_orderbtn">
                        <Link to={`/menu/${currentVenue}/${zone}/order`}>
                            <AppButton btnType="tertiary">
                                {zone == "guest-request"
                                    ? t(
                                          "default:common.buttons.viewOrdrGuestRequest"
                                      )
                                    : t("default:common.buttons.viewOrder")}
                                <span
                                    className={
                                        totalQty > 0
                                            ? `viewordr_count_active ${
                                                  addprod
                                                      ? "animated_count"
                                                      : ""
                                              }`
                                            : "viewordr_count viewordr_count_active"
                                    }
                                >
                                    {totalQty}
                                </span>
                            </AppButton>
                        </Link>
                    </div>
                </div>
            )}
            <Drawer
                title={`${t("dietaryOptions")}`}
                placement={filterPlacement}
                onClose={onClose}
                open={filtervisible}
                className="listing_drawer"
            >
                <div className="filter__drawer">
                    <div className="filter_content_wrapper">
                        {dietTag.map((diet: any, index: number) => {
                            return (
                                <>
                                    <label
                                        className="drawer_dietry_content"
                                        key={index}
                                    >
                                        <span>
                                            {text_truncate({
                                                str: diet?.name,
                                                length: 20,
                                                ending: null,
                                            })}
                                        </span>
                                        <input
                                            type="checkbox"
                                            onChange={() => {
                                                handleCheckbox(diet.id);
                                            }}
                                        />
                                    </label>
                                </>
                            );
                        })}
                    </div>
                </div>
                <div className="filter_applybtn" onClick={handleFilter}>
                    <button>{t("default:common.buttons.apply")}</button>
                </div>
                {/* <div className="listing_apply_btn" onClick={handleFilter}>
                    <button>APPLY</button>
                </div> */}
            </Drawer>

            <Drawer
                title={`${t("drawerWithExtraActions")}`}
                placement={menuPlacement}
                onClose={menuClose}
                visible={menuvisible}
                className="viewmenu_drawer"
            >
                {categoryRes?.categories?.map((category: any, i: number) => {
                    return (
                        <>
                            <div
                                className="menu_categoryitem"
                                onClick={() => handleMenuCheck(category.id)}
                                key={i}
                            >
                                {text_truncate({
                                    str: category.name,
                                    length: 22,
                                    ending: null,
                                })}
                            </div>
                        </>
                    );
                })}
            </Drawer>
        </>
    );
};

export default Index;
